<template>
  <div v-if="pageConfig">
    <XTable :inConfig="pageConfig" :defaultConfig="pageConfig.defaultConfig" ref="table" />
  </div>
</template>

<script>
  import {getPageInfo} from '@/api/api'
  export default {
    props: {
      userId: {
        type: null,
        default: null
      },
      defaultConfig: {
        type: null,
        default: null
      }
    },

    data() {
      return {
        pageConfig: null
      }
    },

    created() {
      getPageInfo({key: 'work_online_log'}).then(res => {
        const data = res.data
        if (this.userId) {
          data.defaultConfig = {}
          data.defaultConfig.user_id = this.userId
        }
        if (this.defaultConfig) {
          data.defaultConfig = this.defaultConfig
        }
        this.pageConfig = data
      })
    },
    methods: {}
  }
</script>

<style lang="scss" scoped></style>
